export enum EOrderLike {
  MOST_RECENT = 'MOST_RECENT',
  OLDEST_LIKED = 'OLDEST_LIKED',
  LINKEDIN_DETAIL_FIRST = 'LINKEDIN_DETAIL_FIRST'
}
